const { cloneDeep } = require('@/functions/clone');
/**
 * Takes the paymentTerminalConfig from a device and sets the payment method configuration for a specific method.
 * Returns the updated device config.
 * This does not modify the device itself, it just returns the updated config, allowing callers to decide when to apply
 * the change to the device.
 *
 * @param {Device} device
 * @param {string} paymentMethodRef
 * @param {object} methodConfig
 *
 * @returns {object}
 */
const modifyDevicePaymentTerminalConfig = (device, paymentMethodRef, methodConfig) => {
    let deviceConfig = device.paymentTerminalConfig ? cloneDeep(device.paymentTerminalConfig) : {};

    if (!deviceConfig.hasOwnProperty(paymentMethodRef)) {
        deviceConfig[paymentMethodRef] = {};
    }

    deviceConfig[paymentMethodRef] = {};

    // Add the new values in a loop so that we don't leave the object as a reference,
    // and we remove things like Vue reactivity. We also only save values if they are non-empty,
    // or if they are specifically 'false'.
    for (const key in methodConfig) {
        if (methodConfig.hasOwnProperty(key) && (methodConfig[key] || methodConfig[key] === false)) {
            deviceConfig[paymentMethodRef][key] = methodConfig[key];
        }
    }

    // Return the updated device config.
    return deviceConfig;
};

/**
 * Check if the currentDevice has a tradingSessionID.
 * If not attempt to fetch it from the API and set it.
 *
 * @param {CurrentDevice} currentDevice
 * @param {TradingSessionManager} tradingSessionManager
 *
 * @return {Promise<void>}
 */
const setDeviceTradingSessionIfMissing = async (currentDevice, tradingSessionManager) => {
    if (!currentDevice.isSet()) {
        return;
    }
    if (currentDevice.getTradingSessionID()) {
        return;
    }
    try {
        // If the device is offline, and we can't fetch the tradingSessionID there is not a lot we can do.
        // But if we catch the error here then the missing tradingSessionID can be handled in more appropriate
        // places such as the OrderValidator;
        const tradingSession = await tradingSessionManager.getCurrentSession(currentDevice.device);
        if (tradingSession) {
            currentDevice.setTradingSession(tradingSession);
        }
    } catch (error) {
        console.error(error);
    }
};

module.exports = {
    modifyDevicePaymentTerminalConfig,
    setDeviceTradingSessionIfMissing,
};
